// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TecnologiasPartners_container__VjtA0 {
    margin-top: 60px;
    margin-bottom: 80px;
}

.TecnologiasPartners_h2-title__hdKnE {
    text-align: center;
    font-size: 46px;
}

.TecnologiasPartners_p-paragraph__peSpe {
    text-align: center;
    font-size: 24px;
    padding: 0 20px;
    margin: 50px 0;
}

.TecnologiasPartners_tech-logos__b-7AM {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    padding-bottom: 50px;
    border-bottom: 1px solid rgba(0, 0, 0, .1);
}



@media screen and (max-width: 1536px) {
    .TecnologiasPartners_h2-title__hdKnE {
        font-size: 40px;
    }

    .TecnologiasPartners_p-paragraph__peSpe {
        font-size: 22px;
    }

    .TecnologiasPartners_tech-logos__b-7AM {
        justify-content: space-between;
    }
}

@media screen and (max-width: 1200px) {
    .TecnologiasPartners_h2-title__hdKnE {
        font-size: 36px;
    }

    .TecnologiasPartners_p-paragraph__peSpe {
        font-size: 20px;
    }
}

@media screen and (max-width: 992px) {
    .TecnologiasPartners_tech-logos__b-7AM {
        flex-wrap: wrap;
        column-gap: 5%;
        row-gap: 25px;
        justify-content: center;
    }

    .TecnologiasPartners_tech-logos__b-7AM img {
        transform: scale(.9);
    }

    .TecnologiasPartners_p-paragraph__peSpe {
        font-size: 18px;
    }

}

@media screen and (max-width: 768px) {
    .TecnologiasPartners_h2-title__hdKnE {
        font-size: 34px;
    }

    .TecnologiasPartners_tech-logos__b-7AM {
        column-gap: 0;
        row-gap: 20px;
    }

    .TecnologiasPartners_tech-logos__b-7AM img {
        transform: scale(.75);
    }
}

@media screen and (max-width: 576px) {
    .TecnologiasPartners_h2-title__hdKnE {
        font-size: 30px;
    }

    .TecnologiasPartners_p-paragraph__peSpe {
        font-size: 16px;
        padding: 0 10px;
    }

    .TecnologiasPartners_tech-logos__b-7AM {
        column-gap: 2%;
        row-gap: 15px;
    }

    .TecnologiasPartners_tech-logos__b-7AM img {
        transform: scale(.7);
    }
}`, "",{"version":3,"sources":["webpack://./src/components/BodyLanding/TecnologiasPartners/TecnologiasPartners.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;IACpB,0CAA0C;AAC9C;;;;AAIA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,cAAc;QACd,aAAa;QACb,uBAAuB;IAC3B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,aAAa;IACjB;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,oBAAoB;IACxB;AACJ","sourcesContent":[".container {\n    margin-top: 60px;\n    margin-bottom: 80px;\n}\n\n.h2-title {\n    text-align: center;\n    font-size: 46px;\n}\n\n.p-paragraph {\n    text-align: center;\n    font-size: 24px;\n    padding: 0 20px;\n    margin: 50px 0;\n}\n\n.tech-logos {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    padding-bottom: 50px;\n    border-bottom: 1px solid rgba(0, 0, 0, .1);\n}\n\n\n\n@media screen and (max-width: 1536px) {\n    .h2-title {\n        font-size: 40px;\n    }\n\n    .p-paragraph {\n        font-size: 22px;\n    }\n\n    .tech-logos {\n        justify-content: space-between;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .h2-title {\n        font-size: 36px;\n    }\n\n    .p-paragraph {\n        font-size: 20px;\n    }\n}\n\n@media screen and (max-width: 992px) {\n    .tech-logos {\n        flex-wrap: wrap;\n        column-gap: 5%;\n        row-gap: 25px;\n        justify-content: center;\n    }\n\n    .tech-logos img {\n        transform: scale(.9);\n    }\n\n    .p-paragraph {\n        font-size: 18px;\n    }\n\n}\n\n@media screen and (max-width: 768px) {\n    .h2-title {\n        font-size: 34px;\n    }\n\n    .tech-logos {\n        column-gap: 0;\n        row-gap: 20px;\n    }\n\n    .tech-logos img {\n        transform: scale(.75);\n    }\n}\n\n@media screen and (max-width: 576px) {\n    .h2-title {\n        font-size: 30px;\n    }\n\n    .p-paragraph {\n        font-size: 16px;\n        padding: 0 10px;\n    }\n\n    .tech-logos {\n        column-gap: 2%;\n        row-gap: 15px;\n    }\n\n    .tech-logos img {\n        transform: scale(.7);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TecnologiasPartners_container__VjtA0`,
	"h2-title": `TecnologiasPartners_h2-title__hdKnE`,
	"p-paragraph": `TecnologiasPartners_p-paragraph__peSpe`,
	"tech-logos": `TecnologiasPartners_tech-logos__b-7AM`
};
export default ___CSS_LOADER_EXPORT___;
